
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[username]",
      function () {
        return require("private-next-pages/c/[username].js");
      }
    ]);
  